module.exports = __webpack_public_path__ + "static/media/FewCloudsMoon02n.b713956a.png";